var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-configuration-logements-container"},[_c('fx-datagrid-crud',{attrs:{"titre":"Gestion des types de logements","url-ressource-end-point":"api/edt/modules/configuration-logements/types"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }